'use client'
import * as React from 'react'
import { Icon, type IconProps } from '../Icon'
const ChevronRightIcon = React.forwardRef((props: IconProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <path d="M17.0306 12.531L9.53062 20.031C9.46093 20.1007 9.37821 20.156 9.28716 20.1937C9.19612 20.2314 9.09854 20.2508 8.99999 20.2508C8.90144 20.2508 8.80386 20.2314 8.71282 20.1937C8.62177 20.156 8.53905 20.1007 8.46936 20.031C8.39968 19.9614 8.34441 19.8786 8.30669 19.7876C8.26898 19.6965 8.24957 19.599 8.24957 19.5004C8.24957 19.4019 8.26898 19.3043 8.30669 19.2132C8.34441 19.1222 8.39968 19.0395 8.46936 18.9698L15.4397 12.0004L8.46936 5.03104C8.32863 4.89031 8.24957 4.69944 8.24957 4.50042C8.24957 4.30139 8.32863 4.11052 8.46936 3.96979C8.61009 3.82906 8.80097 3.75 8.99999 3.75C9.19901 3.75 9.38988 3.82906 9.53062 3.96979L17.0306 11.4698C17.1003 11.5394 17.1557 11.6222 17.1934 11.7132C17.2312 11.8043 17.2506 11.9019 17.2506 12.0004C17.2506 12.099 17.2312 12.1966 17.1934 12.2876C17.1557 12.3787 17.1003 12.4614 17.0306 12.531Z" />
    </Icon>
  )
})
export { ChevronRightIcon }
